import defaultAttributes from '../defaultAttributes';

const Unlink2 = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M15 7h2a5 5 0 010 10h-2m-6 0H7A5 5 0 017 7h2' }]],
];

export default Unlink2;
